import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Vuex from 'vuex';
import moment from 'moment';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import { gsap } from 'gsap/all';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import App from './App.vue'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import "vue-select/dist/vue-select.css";

gsap.registerPlugin( ScrollToPlugin );
moment.locale('fr');
Vue.use(Vuex, VueAxios, axios);
Vue.use(PerfectScrollbar);
Vue.filter('toFixed', function (value, size) {
  if (isNaN(value)) return '';
  return parseFloat(value).toFixed(size);
});
Vue.filter('replace', function (value, toFind, toReplace) {
  return value.replace(toFind, toReplace);
});

axios.defaults.headers.common['SD-Locale'] = window.Translator.locale;
const store = new Vuex.Store({});
new Vue({
  store: store,
  render: h => h(App)
}).$mount('#app-vue')
